export default {
  oilSampleIgnoreFields: {
    modifiedOn: undefined,
    allReportEmails: undefined,
    goodReportEmails: undefined,
    badReportEmails: undefined
  }
};
